import { lazy } from 'react';

export const GeneralSearchPageAsync = lazy(() => import('./GeneralSearch'));
